import { useTranslation } from 'libs/i18n'
import { useParams } from 'libs/router'
import { routes } from 'config/routes'
import { HistoryTable } from 'shared/components'
import { BackButton, Header } from 'shared/components'
import { useFetchProductHistory } from './queries/useFetchProductHistory'

const ProductHistoryPage = () => {
	const { t } = useTranslation()
	const params = useParams()
	const { productHistory, isProductHistoryLoading } = useFetchProductHistory()

	return (
		<>
			<Header
				title={t('Product / History')}
				actions={<BackButton to={routes.productEdit(params.id)} />}
			/>
			<HistoryTable results={productHistory?.data} isLoading={isProductHistoryLoading} />
		</>
	)
}

export default ProductHistoryPage
